export enum Locale {
  DE_DE = 'DE_DE',
  EN_GB = 'EN_GB',
  EN_US = 'EN_US',
}
